export default "__VITE_ASSET__CdXKQ20l__"